import clsx from "clsx"
import {Children, ReactNode, useCallback, useRef} from "react"
import "./Fader.css"

interface FaderComponents {
    Slide: React.FC<{children: ReactNode}>
}

interface FaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "children" | "onSelect"> {
    children: ReactNode
    selected: number
    onSelect?: undefined | ((value: number) => void)
    slideClass?: undefined | string
}

const Fader: React.FC<FaderProps> & FaderComponents = (props: FaderProps) => {
    const {selected, onSelect, className, slideClass, children, ...otherProps} = props
    const touchStartRef = useRef<undefined | number>()

    const onTouchStart = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        touchStartRef.current = event.touches[0]?.screenX
    }, [])

    const onTouchMove = useCallback(
        (event: React.TouchEvent<HTMLDivElement>) => {
            const currentX = event.touches[0]?.screenX

            if (false || typeof currentX === "undefined" || typeof touchStartRef.current === "undefined") {
                return
            }

            const movesLeft = currentX > touchStartRef.current + 50
            const movesRight = currentX < touchStartRef.current - 50

            if (movesLeft) {
                onSelect?.(Math.max(selected - 1, 0))
                touchStartRef.current = undefined
                return
            }
            if (movesRight) {
                onSelect?.(Math.min(selected + 1, Children.count(children) - 1))
                touchStartRef.current = undefined
                return
            }
        },
        [selected],
    )

    return (
        <div {...otherProps} className={clsx("fader-kpz3", className)}>
            {Children.map(children, (child, index) => (
                <div
                    key={index}
                    className={clsx("slide-kpz3", slideClass, {
                        "selected-kpz3": selected === index,
                    })}
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                >
                    {child}
                </div>
            ))}
        </div>
    )
}

export default Fader

const Slide: React.FC<{children: ReactNode}> = props => <>{props.children}</>

Fader.Slide = Slide
